export default __webpack_public_path__ + "static/media/metering-systems.372217e7.jpg";